import { Component } from "@/types/types"
import { cx } from "@/utils/cx"
import { Link } from "../Link"
import { ReactNode } from "react"

export const COMPONENT_NAME = "buttonLink"

export const presets = {
  variant: {
    primary: "text-text-onaccent bg-fill-accent [&:not(:disabled)]:hover:bg-fill-accent-hover",
    secondary:
      "text-text-primary bg-fill-secondary [&:not(:disabled)]:hover:bg-fill-secondary-hover",
    ghost: "text-text-primary bg-transparent [&:not(:disabled)]:hover:bg-fill-secondary-hover",
    danger: "text-text-inverse bg-fill-critical [&:not(:disabled)]:hover:bg-fill-critical-hover",
    sans: "text-white bg-[#005980] [&:not(:disabled)]:hover:bg-[#004F71] [&:disabled]:opacity-25",
  },
  width: {
    contained: "w-full max-w-[144px]",
    full: "w-full",
  },
}

export interface Props extends Component {
  label: string
  labelPrefix?: ReactNode
  variant: keyof typeof presets.variant
  width?: keyof typeof presets.width
  disabled?: boolean
  href: string
  prefetch?: boolean
  onClick?: () => void
}

export function ButtonLink({
  label,
  labelPrefix,
  variant,
  width = "contained",
  href,
  onClick,
  disabled,
  prefetch = true,
  className,
  testId = COMPONENT_NAME,
}: Props) {
  return (
    <Link
      className={cx(
        `h-12 font-semibold rounded px-4 select-none whitespace-nowrap flex items-center justify-center gap-2`,
        "transition",
        presets.variant[variant],
        presets.width[width],
        disabled && "opacity-50 pointer-events-none",
        !disabled && "focus:outline-none focus-ring",
        className,
      )}
      href={href}
      testId={testId}
      disabled={disabled}
      onClick={onClick}
      prefetch={prefetch}
    >
      {labelPrefix}
      {label}
    </Link>
  )
}
